<template>
  <div class="weather-warp wh-flex-between">
    <el-image
      style="width: 75px; height: 75px"
      :src="weatherData.cond_img || weatherIcon"
      fit="contain"
    />
    <div class="weather-txt">
      <div class="txt-item wh-flex-between">
        <span>{{ weatherData.tmp - 2 || 30 }} ~ {{ parseInt(weatherData.tmp) + 2 || 30 }}°</span>
        <span>{{ weatherData.cond_txt }}</span>
      </div>
      <div class="txt-item wh-flex-between">
        <span>空气质量 {{ weatherData.vis || 40 }}</span>
        <span>优</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'WhWeatherBox',
  data() {
    return {
      weatherIcon: require('./images/weather-icon.png'),
      weatherData: {
        cond_img: require('./images/weather-icon.png')
      }
    }
  },
  created() {
    this.getWeather('达州市')
    setInterval(() => {
      this.getWeather('达州市')
    }, 1000 * 60 * 30)
  },
  beforeDestroy() {},
  methods: {
    getWeather(addr) {
      const src = `https://free-api.heweather.net/s6/weather/now?`
      axios.get(src, {
        params: {
          location: addr,
          key: '6496b85d9c2e4756b97a1bbd214cb7d5'
        }
      }).then(resp => {
        this.weatherData = resp.data.HeWeather6[0].now
        this.weatherData.cond_img = require(`./images/${resp.data.HeWeather6[0].now.cond_code || 100}.png`)
      }).catch(() => {
        this.$notify.warning('网络异常获取天气失败')
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .weather-warp{

  }
  .weather-txt{
    margin-left: 28px;
    color: #FFFFFF;
    font-size: 26px;
    .txt-item{
      width: 190px;
      line-height: 1.4;
    }
  }
</style>
